<style lang="less">
@import './main.less';
</style>
<style lang="less">
// @import '../styles/variable.less';
    .needCertification {
        font-size: 13px !important;
        margin-left: 20px;
        cursor: pointer;
        display: inline-block;
        color: #ff9100;
        background: #fff3e4;
        border-radius: 50px;
        padding: 0 15px;
        line-height: 30px;
    }
</style>
<template>
    <div class="main" :class="{'main-hide-text': hideMenuText}">
        <div class="sidebar-menu-con" :style="{width: hideMenuText?'60px':'135px', overflow: hideMenuText ? 'visible' : 'auto', background: $store.state.menuTheme === 'dark'?'#24363f':'white'}">
            <sidebar-menu v-if="!hideMenuText" :menuList="menuList" :iconSize="14" />
            <sidebar-menu-shrink :icon-color="menuIconColor" v-else :menuList="menuList" />
        </div>
        <div class="main-header-con">
            <div class="main-header">
                <div class="navicon-con">
                    <Button :style="{transform: 'rotateZ(' + (this.hideMenuText ? '-90' : '0') + 'deg)'}" type="text" @click="toggleClick">
                        <Icon type="navicon" size="32"></Icon>
                    </Button>
                </div>
                <div class="header-middle-con">
                    <span v-if="isShowTest">鸭嘴兽演示账号</span>
                    <span v-else v-text="user.companyName"></span>
                    <Tooltip content="已实名认证" placement="right">
                        <i class="iconfont icondunpai" style="color:#19be6b" v-if="needCertification && companyCertificationStatus" />
                    </Tooltip>
                    <span v-if="needCertification && !companyCertificationStatus" @click="showModal" class="needCertification">请完成实名认证</span>
                </div>
                <div class="header-avator-con">
                    <div class="home-link" id="home-link" v-if="!isShowXiniyuan"><!--这边为了区分前台和后台，加了全局唯一id-->
                        <a href="javascript:void(0)" @click="toIndex">返回主页</a>
                    </div>
                    <div class="user-dropdown-menu-con">
                        <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
                            <Dropdown transfer trigger="click" @on-click="handleClickUserDropdown">
                                <a href="javascript:void(0)">
                                    <span class="main-user-name">{{ user.userDisplayName }}</span>
                                    <Icon type="arrow-down-b"></Icon>
                                </a>
                                <DropdownMenu slot="list">
                                    <DropdownItem name="personalCenter">个人中心</DropdownItem>
                                    <DropdownItem name="loginout" divided>退出登录</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                            <Avatar icon="person" style="background: #619fe7;margin-left: 10px;"></Avatar>
                        </Row>
                    </div>
                </div>
            </div>
            <div class="tags-con">
                <tags-page-opened :pageTagsList="pageTagsList" :style="{marginLeft: hideMenuText?'60px':'120px'}"></tags-page-opened>
            </div>
        </div>
        <div class="single-page-con" :style="{left: hideMenuText?'60px':'120px'}">
            <div class="single-page">
                <keep-alive :include="cachePage">
                    <router-view></router-view>
                </keep-alive>
            </div>
        </div>
        <Modal v-model="modifyPasswordModal" title="修改密码" :width="500">
            <Form ref="modifyPasswordForm" :model="modifyPasswordForm" :label-width="100" label-position="right" :rules="passwordValidate">
                <FormItem label="原密码" prop="oldPass" :error="oldPassError" v-if="hasPassword">
                    <Input v-model="modifyPasswordForm.oldPass" placeholder="请输入现在使用的密码" ></Input>
                </FormItem>
                <FormItem label="新密码" prop="newPass">
                    <Input v-model="modifyPasswordForm.newPass" placeholder="密码必须为8-16位且包含字母及数字" ></Input>
                </FormItem>
                <FormItem label="确认新密码" prop="rePass">
                    <Input v-model="modifyPasswordForm.rePass" placeholder="请输入确认密码" ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" @click="cancelModifyPass">取消</Button>
                <Button type="primary" :loading="savePassLoading" @click="saveModifyPass">保存</Button>
            </div>
        </Modal>
        <certificationModal ref="certificationModal" />
    </div>
</template>
<script>
import sidebarMenu from './main_components/sidebarMenu.vue';
import tagsPageOpened from './main_components/tagsPageOpened.vue';
import breadcrumbNav from './main_components/breadcrumbNav.vue';
import themeDropdownMenu from './main_components/themeDropdownMenu.vue';
import sidebarMenuShrink from './main_components/sidebarMenuShrink.vue';
import Cookies from 'js-cookie';
import util from '@/libs/util.js';
import axios from 'axios';
import {mapGetters} from 'vuex'
import {xinjiyuanMenuList} from '@/api/menuList';
import { getCompanyMsgPlus } from '@/api/home'
import { userInfo } from "@/api/certification";
import certificationModal from '../components/certification-modal'
import { encrypt, decode } from "@/libs/encrypt-and-decode.js"
export default {
    components: {
        sidebarMenu,
        tagsPageOpened,
        breadcrumbNav,
        themeDropdownMenu,
        sidebarMenuShrink,
        certificationModal
    },
    data() {
        const validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'))
            } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(value)) {
                callback(new Error('密码必须为8-16位且包含字母及数字'))
            } else {
                if(!this.modifyPasswordForm.rePass) {
                    this.$refs.modifyPasswordForm.validateField('rePass')
                }
                callback()
            }
        };
        const valideRePassword = (rule, value, callback) => {
            if (value !== this.modifyPasswordForm.newPass) {
                callback(new Error('两次输入密码不一致'));
            } else {
                callback();
            }
        };
        return {
            isShowXiniyuan:Cookies.get('isVest') == 'true' ? true : false,
            spanLeft: 4,
            spanRight: 20,
            currentPageName: '',
            hideMenuText: false,
            userName: '',
            showFullScreenBtn: window.navigator.userAgent.indexOf('MSIE') < 0,
            messageCount: 0,
            lockScreenSize: 0,
            // current请求返回得user信息
            user: {},
            // 修改密码弹窗
            modifyPasswordModal: false,
            savePassLoading: false,
            oldPassError: '',
            modifyPasswordForm: {
                oldPass: '',
                newPass: '',
                rePass: ''
            },
            passwordValidate: {
                oldPass: [
                    { required: true, message: '请输入原密码', trigger: 'blur' }
                ],
                newPass: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    // { min: 6, message: '请至少输入6个字符', trigger: 'blur' },
                    // { max: 32, message: '最多输入32个字符', trigger: 'blur' }
                    { validator: validatePassword, trigger: 'blur' }
                ],
                rePass: [
                    { required: true, message: '请再次输入新密码', trigger: 'blur' },
                    { validator: valideRePassword, trigger: 'blur' }
                ]
            },
            hasPassword: true,
            needCertification: false,
            companyCertificationStatus:true,
        };
    },
    computed: {
        isShowTest() {
            console.log('username--->)', decode(Cookies.get('user')))
            return ['demo_portsh', 'demo_portnb', 'demo_portqd', 'demo_portsz', 'demo_porttj', 'demo_porttc', 'demo_sme1', 'demo_sme2', 'demo_sme3', 'demo_citydg', 'demo_citygz', 'demo_cityfs', 'demo_cityzs' ,'demo_cityhz'].includes(decode(Cookies.get('user')))
        },
        ...mapGetters([
            'getMenuList'
        ]),
        menuList() {
            return this.getMenuList;
        },
        tagsList() {
            return this.$store.state.tagsList; // 所有页面的页面对象
        },
        pageTagsList() {
            // 过滤掉一些页面的展示
            return this.$store.state.pageOpenedList
                .filter(v => !['place-order-pre', 'create-history-order', 'LCL-order'].includes(v.name)); // 打开的页面的页面对象
        },
        currentPath() {
            return this.$store.state.currentPath; // 当前面包屑数组
        },
        menuIconColor() {
            return this.$store.state.menuTheme === 'dark' ? 'white' : '#35445e';
        },
        avatorPath() {
            return localStorage.avatorImgPath;
        },
        cachePage() {
            return this.$store.state.cachePage;
        },
        lang() {
            return this.$store.state.lang;
        },
        isFullScreen() {
            return this.$store.state.isFullScreen;
        }
    },
    watch: {
        hasPassword(val) {
            if(val) {
                this.passwordValidate.oldPass = [{ required: true, message: '请输入原密码', trigger: 'blur' }]
            }else {
                this.passwordValidate.oldPass = []
            }
        }
    },
    methods: {
        baiduTongji(obj) {
            try {
                _hmt.push(['_trackEvent', '登录用户记录浏览器分辨率/屏幕的分辨率', `浏览器分辨率宽：${obj.webpage.width}px 高：${obj.webpage.height}px 屏幕分辨率宽：${obj.screen.width}px 高：${obj.screen.height}px`,
                    Cookies.get("userId") ? `企业名：${Cookies.get('companyName')} 用户名:${Cookies.get('userId')}` : '未登录'])
                console.log(`浏览器分辨率宽：${obj.webpage.width}px 高：${obj.webpage.height}px 屏幕分辨率宽：${obj.screen.width}px 高：${obj.screen.height}px`,'&&&')
            } catch (e) {
                console.log("浏览器分辨率/屏幕的分辨率统计时报错")
        }
        },
        showModal(){
            this.$refs.certificationModal.show(true)
        },
        // 获取个人信息
        getUserInfo() {
            userInfo({}).then((res) => {
                if (res && res.data.success) {
                    if (res.data.data.needCertification && res.data.data.companyCertificationStatus != "Verify"){
                        this.showModal()
                    }
                    res.data.data.needCertification = true
                    this.needCertification = res.data.data.needCertification
                    res.data.data.companyCertificationStatus != "Verify" ? this.companyCertificationStatus= false : this.companyCertificationStatus= true
                }
            })
        },
        init() {
            this.$store.commit('setCurrentPageName', this.$route.name);
            let pathArr = util.setCurrentPath(this, this.$route.name);
            if (pathArr.length >= 2) {
                this.$store.commit('addOpenSubmenu', pathArr[1].name);
            }
            this.userName = decode(Cookies.get('user'));
            let messageCount = 3;
            this.messageCount = messageCount.toString();
            this.checkTag(this.$route.name);
            this.getUserInfo()
        },
        toggleClick() {
            this.hideMenuText = !this.hideMenuText;
        },
        handleClickUserDropdown(name) {
            if (name === 'ownSpace') {
                util.openNewPage(this, 'ownspace_index');
                this.$router.push({
                    name: 'ownspace_index'
                });
            } else if (name === 'loginout') {
                // 退出登录
                Cookies.remove('user');
                Cookies.remove('password');
                Cookies.remove('hasGreet');
                Cookies.remove('access');
                Cookies.remove('authorities');
                Cookies.remove('customerLevel')
                Cookies.remove('userId')
                this.$Notice.close('greeting');
                this.$store.commit('clearOpenedSubmenu');
                // 回复默认样式
                let themeLink = document.querySelector('link[name="theme"]');
                themeLink.setAttribute('href', '');
                // 清空打开的页面等数据，但是保存主题数据
                let theme = '';
                if (localStorage.theme) {
                    theme = localStorage.theme;
                }
                // localStorage.clear();
                if (theme) {
                    localStorage.theme = theme;
                }
                this.logout();
            } else if (name === 'modifyPassword') {
                // 修改密码
                for (const prop in this.modifyPasswordForm) {
                    if (this.modifyPasswordForm.hasOwnProperty(prop)) {
                        this.modifyPasswordForm[prop] = '';
                    }
                }
                util.ajax_get(this, '/ws-truck/user/valid_password', {}, res => {
                    this.hasPassword = JSON.parse(res.data.data.value)
                    this.modifyPasswordModal = true;
                })
                // this.modifyPasswordModal = true;
            }else if (name === 'personalCenter'){
                this.$router.push({
                    name: 'personal-center'
                });
            }
        },
        handleFullScreen() {
            this.$store.commit('handleFullScreen');
            // this.$store.commit('changeFullScreenState');
        },
        showMessage() {
            util.openNewPage(this, 'message_index');
            this.$router.push({
                name: 'message_index'
            });
        },
        toPath(pathName){
           this.$router.push({
                name: pathName
            });
        },
        lockScreen() {
            let lockScreenBack = document.getElementById('lock_screen_back');
            lockScreenBack.style.transition = 'all 3s';
            lockScreenBack.style.zIndex = 10000;
            lockScreenBack.style.boxShadow =
                '0 0 0 ' + this.lockScreenSize + 'px #667aa6 inset';
            this.showUnlock = true;
            this.$store.commit('lock');
            Cookies.set('last_page_name', this.$route.name); // 本地存储锁屏之前打开的页面以便解锁后打开
            setTimeout(() => {
                lockScreenBack.style.transition = 'all 0s';
                this.$router.push({
                    name: 'locking'
                });
            }, 800);
        },
        checkTag(name) {
            let openpageHasTag = this.pageTagsList.some(item => {
                if (item.name === name) {
                    return true;
                }
            });
            if (!openpageHasTag) {
                //  解决关闭当前标签后再点击回退按钮会退到当前页时没有标签的问题
                util.openNewPage(
                    this,
                    name,
                    this.$route.params || {},
                    this.$route.query || {}
                );
            }
        },
        // 登出
        logout() {
            util.ajax_get(this, '/ws-truck/user/logout', {}, response => {
                window.localStorage.removeItem('Bearer')
                if (response.data.success) {
                    this.$router.push({ name: 'index' });
                    window.location.reload();
                }
            });
        },
        // 点击鸭嘴兽logo触发方法
        toIndex() {
            this.$router.push({
                name: 'index'
            });
        },
        // 获取当前用户信息
        getCurrentUser() {
            util.ajax_get(this, '/ws-truck/user/current', Date.now(), response => {
                if (response.data.success) {
                    util.updataMenuBadge(this)//检查菜单小红点
                    this.user = response.data.user;
                    Cookies.set('user', encrypt(this.user.userName));
                    Cookies.set('companyName', this.user.companyName);
                    Cookies.set('access', response.data.user.clientUserGroup);
                    Cookies.set("isVest", this.user.isVest);
                    if (response.data.user.isVest){
                        Cookies.set("authorities",xinjiyuanMenuList.join(','));
                    }else {
                        Cookies.set("authorities",response.data.user.authorities.join(','));
                    }
                    Cookies.set('accountPeriod', response.data.user.accountPeriod);
                    Cookies.set('settlementType', response.data.user.settlementType);
                    // util.piwik(this.user);
                    getCompanyMsgPlus().then(res => {
                        Cookies.set("companyName", res.data.data.value);
                        if (res && res.data){
                            this.user.companyName = JSON.parse(res.data.data.value)
                        }
                    })
                } else {
                    this.user = {};
                    this.toIndex();
                }
            });
        },
        // 修改密码弹窗按键操作
        cancelModifyPass() {
            this.modifyPasswordModal = false;
        },
        saveModifyPass() {
            this.$refs['modifyPasswordForm'].validate(valid => {
                if (valid) {
                    this.savePassLoading = true;
                    let req = {
                        current_password: this.modifyPasswordForm.oldPass,
                        new_password: this.modifyPasswordForm.newPass,
                        re_new_password: this.modifyPasswordForm.rePass
                    };
                    util.ajax_get(this, '/ws-truck/user/reset_password', req, response => {
                        if (response.data.success) {
                            this.$Message.info('修改成功');
                            this.modifyPasswordModal = false;
                        } else {
                            this.$Message.info(response.data.message);
                        }
                        this.savePassLoading = false;
                    });
                }
            });
        }
    },
    watch: {
        $route(to) {
            // util.piwik(this.user);
            this.$store.commit('setCurrentPageName', to.name);
            let pathArr = util.setCurrentPath(this, to.name);
            if (pathArr.length > 2) {
                this.$store.commit('addOpenSubmenu', pathArr[1].name);
            }
            this.checkTag(to.name);

            // 更新 舱单编辑页面url
            if (to.name === "edit-shipping-bill") {
                this.$store.commit('updateTag', {
                    name: "edit-shipping-bill",
                    data: {
                        query: to.query
                    }
                });
            }
        },
        lang() {
            util.setCurrentPath(this, this.$route.name); // 在切换语言时用于刷新面包屑
        }
    },
    mounted() {
        this.baiduTongji({
            webpage: {
                width: window.innerWidth * (window.devicePixelRatio || 1),
                height: window.innerHeight * (window.devicePixelRatio || 1)
            },
            screen: {
                width: window.screen.width * (window.devicePixelRatio || 1),
                height: window.screen.height * (window.devicePixelRatio || 1)

            }
        })
        this.init();
        if (window.sessionStorage.getItem('plateNumber')) {
            window.sessionStorage.removeItem('plateNumber');
        }
        // 锁屏相关
        let lockScreenBack = document.getElementById('lock_screen_back');
        let x = document.body.clientWidth;
        let y = document.body.clientHeight;
        let r = Math.sqrt(x * x + y * y);
        let size = parseInt(r);
        this.lockScreenSize = size;
        window.addEventListener('resize', () => {
            let x = document.body.clientWidth;
            let y = document.body.clientHeight;
            let r = Math.sqrt(x * x + y * y);
            let size = parseInt(r);
            this.lockScreenSize = size;
            lockScreenBack.style.transition = 'all 0s';
            lockScreenBack.style.width = lockScreenBack.style.height =
                size + 'px';
        });
        lockScreenBack.style.width = lockScreenBack.style.height = size + 'px';
        // 问候信息相关
        if (!Cookies.get('hasGreet')) {
            let now = new Date();
            let hour = now.getHours();
            let greetingWord = {
                title: '',
                words: ''
            };
            let userName = decode(Cookies.get('user'));
            if (hour > 5 && hour < 6) {
                greetingWord = {
                    title: '凌晨好~' + userName,
                    words: '早起的鸟儿有虫吃~'
                };
            } else if (hour >= 6 && hour < 9) {
                greetingWord = {
                    title: '早上好~' + userName,
                    words: '来一杯咖啡开启美好的一天~'
                };
            } else if (hour >= 9 && hour < 12) {
                greetingWord = {
                    title: '上午好~' + userName,
                    words: '工作要加油哦~'
                };
            } else if (hour >= 12 && hour < 14) {
                greetingWord = {
                    title: '中午好~' + userName,
                    words: '午饭要吃饱~'
                };
            } else if (hour >= 14 && hour < 17) {
                greetingWord = {
                    title: '下午好~' + userName,
                    words: '下午也要活力满满哦~'
                };
            } else if (hour >= 17 && hour < 19) {
                greetingWord = {
                    title: '傍晚好~' + userName,
                    words: '下班没事问候下爸妈吧~'
                };
            } else if (hour >= 19 && hour < 21) {
                greetingWord = {
                    title: '晚上好~' + userName,
                    words: '工作之余品一品书香吧~'
                };
            } else {
                greetingWord = {
                    title: '深夜好~' + userName,
                    words: '夜深了，注意休息哦~'
                };
            }
            this.$Notice.config({
                top: 130
            });
            this.$Notice.info({
                title: greetingWord.title,
                desc: greetingWord.words,
                duration: 4,
                name: 'greeting'
            });
            Cookies.set('hasGreet', 1);
        }
                util.ajax_get(this, '/ws-truck/duckBill/getUnevaluateCountByIsAccountIsolation', {}, response => {
                    if (response.data.success) {
                        let data = response.data.data.value;
                        if(Number(data)){
                            this.$store.state.canEvaluate = true;
                        }else{
                            this.$store.state.canEvaluate = false;
                        }
                        this.$store.state.evaluateNumber = data;
                    }
                });
    },
    created() {
        // 查找当前用户之前登录时设置的主题
        let name = decode(Cookies.get('user'));
        if (localStorage.theme) {
            let hasThisUser = JSON.parse(localStorage.theme).some(item => {
                if (item.userName === name) {
                    this.$store.commit('changeMenuTheme', item.menuTheme);
                    this.$store.commit('changeMainTheme', item.mainTheme);
                    return true;
                } else {
                    return false;
                }
            });
            if (!hasThisUser) {
                this.$store.commit('changeMenuTheme', 'dark');
                this.$store.commit('changeMainTheme', 'b');
            }
        } else {
            this.$store.commit('changeMenuTheme', 'dark');
            this.$store.commit('changeMainTheme', 'b');
        }
        // 根据用户设置主题
        if (this.$store.state.theme !== 'b') {
            let stylesheetPath = './dist/' + this.$store.state.theme + '.css';
            let themeLink = document.querySelector('link[name="theme"]');
            themeLink.setAttribute('href', stylesheetPath);
        }
        // 显示打开的页面的列表
        this.$store.commit('setOpenedList');
        // current请求
        this.getCurrentUser();
    }
};
</script>


// WEBPACK FOOTER //
// Main.vue?cc679eec